import * as THREE from "three";

const vertexShaderSpecial = `
attribute vec2 a_Extrude;
attribute float a_Side;
attribute float a_Time;
attribute float a_TotalTime;
attribute float a_Speed;
attribute float a_Random;
attribute float a_Power;

uniform mat4 u_ScreenFromLocal;
uniform mat4 u_Rotation;
uniform mat4 u_ClipFromScreen;
uniform float u_PixelRatio;
uniform float make3D;

varying float v_Side;
varying float v_Time;
varying float v_TotalTime;
varying float v_Speed;
varying float v_Random;
varying float v_Power;

void main(void) {


  vec4 screenPosition = vec4(position.xy, 0.0, 1.0);

  //screenPosition.z += (a_Power+a_Speed)-3.;

  //screenPosition += u_Rotation * vec4(a_Extrude, 0.0, 0.0) * 3.0 * u_PixelRatio;
  gl_Position = projectionMatrix * modelViewMatrix * screenPosition;
  v_Side = a_Side;
  v_Time = a_Time;
  v_TotalTime = a_TotalTime;
  v_Speed = a_Speed;
  v_Random = a_Random;
  v_Power = a_Power;

}`;
const fragmentShaderSpecial = `precision mediump float;

uniform vec4 u_Color;
uniform float u_Time;

uniform float periodScale;
uniform float timeScale;

varying float v_Side;
varying float v_Time;
varying float v_TotalTime;
varying float v_Speed;
varying float v_Random;
varying float v_Power;

vec4 getColor(float value) {
  // Normalized value between 0 and 1
  float t = value / 100.0;

  // Define the color ranges using vec3
  vec4 red = vec4(1.0, 0.2196, 0.3922, 0.0);
  vec4 orange = vec4(1.0, 0.4706, 0.0, 0.5);
  vec4 yellow = vec4(0.9490, 0.9137, 0.3059, 1.0);
  vec4 green = vec4(0.2902, 0.9412, 0.4588, 1.0);

  // Smoothstep ranges
  float t0 = smoothstep(0.0, 0.2, t);
  float t1 = smoothstep(0.2, 0.4, t);
  float t2 = smoothstep(0.4, 0.6, t);
  float t3 = smoothstep(0.6, 1.0, t);

  // Interpolate colors
  vec4 color1 = mix(red, orange, t0);
  vec4 color2 = mix(orange, yellow, t1);
  vec4 color3 = mix(yellow, green, t2);

  // Final color mix
  vec4 finalColor = mix(color1, color2, t2);
  finalColor = mix(finalColor, color3, t3);

  return finalColor;
}



void main(void) {

    gl_FragColor = u_Color;
    //gl_FragColor.a *= 1.0 - length(v_Speed);

    float period = v_TotalTime * periodScale;
    float t = mod(v_Speed * u_Time * 3. + period * v_Random * 3.1, period) - v_Time;

    gl_FragColor.a *= step(0.1, t) * exp(-5.3 * t / (v_TotalTime * timeScale));

    //gl_FragColor.b = v_Speed;
    vec4 c = getColor(v_Power * 300.);
    gl_FragColor.rgb = c.rgb;
    gl_FragColor.a *= c.a;

     //gl_FragColor.a *= v_Power*8.;

   // gl_FragColor.rgb *= gl_FragColor.a;

}`;

const vertexShader = `
varying float vUv;

void main() {
  vUv = uv.x; 
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;

const fragmentShader = `
uniform vec3 color;
varying float vUv;

void main() {
  float opacity = mix(0.0, 1.0, vUv);
  gl_FragColor = vec4(color, opacity);
}
`;

const shaderMaterial = new THREE.ShaderMaterial({
  vertexShader,
  fragmentShader,
  uniforms: {
    color: { value: new THREE.Color(0xffffff) },
  },
  transparent: true,
  depthTest: false,
});

const shaderMaterialSpecial = new THREE.ShaderMaterial({
  vertexShader: vertexShaderSpecial,
  fragmentShader: fragmentShaderSpecial,
  uniforms: {
    u_Color: { value: new THREE.Vector4(1, 1, 1, 1) },
    u_Time: { value: 0.0 },
    u_PixelRatio: { value: 1 },
    periodScale: { value: 1.5 },
    timeScale: { value: 1.5 },
    make3D: { value: 1 },
  },
  transparent: true,
  depthTest: true,
  depthWrite: false,
});

export { shaderMaterial, shaderMaterialSpecial };
